import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UploadPage from "./components/UploadPage";
import UploadUIDPage from "./components/UploadUIDPage"; // 🔄 Nowy uploader
import UploadPinkpetPage from "./components/UploadPinkpetPage";
import ViewerPage from "./components/ViewerPage";
import AuthPage from "./components/AuthPage";
import GeoCar from "./components/GeoCar";
import ChooseUploadMode from "./components/ChooseUploadMode"; // 🔄 Ekran wyboru trybu

function App() {
  const [authKey, setAuthKey] = useState(null);

  return (
    <Router>
      <Routes>
        {/* Strona główna – login lub wybór trybu */}
        <Route
          path="/"
          element={
            authKey
              ? <ChooseUploadMode authKey={authKey} />
              : <AuthPage onAuthSuccess={setAuthKey} />
          }
        />

        {/* Tryb 1 – uploader z UID */}
        <Route path="/upload-uid" element={<UploadUIDPage authKey={authKey} />} />

        <Route path="/upload-pinkpet" element={<UploadPinkpetPage authKey={authKey} />} />

        {/* Tryb 2 – klasyczny uploader */}
        <Route path="/upload-old" element={<UploadPage authKey={authKey} />} />

        {/* Strona podglądu zdjęcia */}
        <Route path="/viewer/:id" element={<ViewerPage />} />

        {/* GeoCar */}
        <Route path="/geocar/:id" element={<GeoCar />} />
      </Routes>
    </Router>
  );
}

export default App;
